
<script>
    import { io } from './store.js';
    import Landing from './Landing.svelte';
    import Header from './Header.svelte';
    import Footer from './Footer.svelte';
    import HowToPlay from './HowToPlay.svelte';
    import Contact from './Contact.svelte';
    import Verify from './Verify.svelte';
    import Setup from './Setup.svelte';

    export var pages = {  Landing, HowToPlay, Contact, Verify, Setup };

    var pathname = new URL(window.location.href).pathname;
    var firstSlash = pathname.split('/')[1];

    console.log(firstSlash);

    $io.activePage = 'Landing';
    if(firstSlash == 'howtoplay')
        $io.activePage = 'HowToPlay';
    if(firstSlash == 'contact')
        $io.activePage = 'Contact';
    if(firstSlash == 'verify')
        $io.activePage = 'Verify';
    if(firstSlash == 'setup')
        $io.activePage = 'Setup';

    UT.Extensions();
    //window.io = $io;

    function changePage(event){
        console.log(event);
        if(event.detail.name)
            $io.activePage = pages[event.detail.name];
	}

</script>

<svelte:component this={Header} on:page={changePage}></svelte:component>

<svelte:component this={pages[$io.activePage]} on:page={changePage}></svelte:component>

<svelte:component this={Footer} on:page={changePage}></svelte:component>


<style type="text/less">

    :global(html){
        --mwidth: 1000px;
    }

    :global(h1, h2){
        font-family: oxanium, sans-serif;
        stroke-width: 2px;
        -webkit-text-stroke-color: #756b46;
        -webkit-text-stroke-width: 2px;
        letter-spacing: 1.75px;
        color:#9ed085;
        font-size:2em;
        margin:0;
        line-height:1em;
    }

    :global(a){
        color: #2d96ff !important;
    }

    :global(body){
        font-size:16px;
        color:#fffef9;
        padding:24px;
        background-color: #0e0d0a;
        //background-color: #e9e7e4;
        font-family: oxanium, sans-serif;
        font-weight:600;
    }

    :global(.btn){
        display:flex;
        justify-content: center;;
        box-shadow: 0 0 2px 1px rgb(0, 0, 0);
    }

    :global(.con-modal){
        display:grid;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1040;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(3px);

        :global(.div-close){
            position:absolute;
            right:5px;
            top:-5px;
            font-weight:bold;
            font-size:30px;
            opacity:0.4;
            &:hover{
                cursor:pointer;
                opacity:1;
            }
        }

        :global(.con-edit){
            display:grid;
            justify-self:center;
            justify-items:center;
            top:100px;
            position:fixed;
            border-radius:5px; 
            
            background-color:rgb(240, 240, 240);
            padding:20px;
            min-width:300px;
            //width:50%;
            max-width:90%;
            min-height:100px;
            border:1px solid rgba(255, 255, 255, 0.397);
            box-shadow: 0 0 2px 1px #000000a1;
        }
    }

    @media (max-width: 900px) {
        :global(body){
            padding:10px !important;
			
			zoom:0.7;

        }
    }

</style>